import { useState, useCallback } from 'react';

export const useForm = (initialValues = {}) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback((field, value) => {
    setValues(prev => {
      if (field.includes('.')) {
        const [parent, child, subChild] = field.split('.');
        return {
          ...prev,
          [parent]: {
            ...prev[parent],
            [child]: subChild ? {
              ...prev[parent][child],
              [subChild]: value
            } : value
          }
        };
      } else {
        return { ...prev, [field]: value };
      }
    });

    if (errors[field]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  }, [errors]);

  const validate = useCallback((rules) => {
    const newErrors = {};
    
    for (const [field, rule] of Object.entries(rules)) {
      const fieldValue = field.includes('.') ? 
        field.split('.').reduce((obj, key) => obj?.[key], values) : 
        values[field];
      
      // rule이 배열인 경우 처리
      const rulesArray = Array.isArray(rule) ? rule : [rule];
      let error = null;
      
      for (const singleRule of rulesArray) {
        if (typeof singleRule === 'function') {
          error = singleRule(fieldValue);
          if (error) break; // 첫 번째 오류에서 중단
        }
      }
      
      if (error) {
        newErrors[field] = error;
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [values]);

  const resetForm = useCallback(() => {
    setValues(initialValues);
    setErrors({});
  }, [initialValues]);

  return {
    values,
    errors,
    handleChange,
    validate,
    resetForm,
    setValues,
    setErrors
  };
};

export const validationRules = {
  required: (message = '필수 항목입니다.') => (value) => {
    if (!value || value.toString().trim() === '') {
      return message;
    }
    return null;
  },

  businessNumber: (message = '사업자등록번호는 10자리 숫자여야 합니다.') => (value) => {
    if (value && value.replace(/\D/g, '').length !== 10) {
      return message;
    }
    return null;
  }
};
